export default __webpack_public_path__ + "scenes4458195.png";